<template>
  <div id="app">
    <AppNav />
    <main>
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppNav from './components/AppNav.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: { AppNav, AppFooter }
}
</script>

<style>
/* ====== CSS Reset & Base ====== */
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth;-webkit-text-size-adjust:100%}
body{
  font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC',
    'Hiragino Sans GB','Microsoft YaHei','Helvetica Neue',Helvetica,Arial,sans-serif;
  background:#0b1120;
  color:#e2e8f0;
  line-height:1.6;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
  overflow-x:hidden;
}
h1,h2,h3,h4,h5{
  font-family:'Space Grotesk','Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',
    'PingFang SC','Microsoft YaHei',sans-serif;
  font-weight:600;line-height:1.2;
}
a{color:inherit;text-decoration:none}
img{max-width:100%;display:block}
ul{list-style:none}

/* ====== Layout ====== */
.container{width:100%;max-width:1200px;margin:0 auto;padding:0 24px}
.section{padding:100px 0}

/* ====== Section Header ====== */
.section-header{text-align:center;margin-bottom:56px}
.section-header .label{
  display:inline-block;
  padding:5px 16px;
  background:rgba(59,130,246,.08);
  border:1px solid rgba(59,130,246,.15);
  border-radius:20px;
  font-size:12.5px;
  font-weight:600;
  color:#60a5fa;
  letter-spacing:1.5px;
  text-transform:uppercase;
  margin-bottom:16px;
}
.section-header h2{
  font-size:clamp(26px,3.5vw,38px);
  font-weight:800;
  color:#f1f5f9;
  margin-bottom:12px;
  letter-spacing:-.01em;
}
.section-header p{
  font-size:15px;
  color:#64748b;
  max-width:560px;
  margin:0 auto;
  line-height:1.7;
}

/* ====== Buttons ====== */
.btn{
  display:inline-flex;align-items:center;justify-content:center;
  font-weight:600;font-size:14px;border-radius:8px;
  cursor:pointer;transition:all 0.3s cubic-bezier(.4,0,.2,1);
  border:none;text-decoration:none;gap:6px;
  font-family:inherit;
}
.btn-primary{
  background:linear-gradient(135deg,#3b82f6,#2563eb) !important;
  color:#fff !important;
}
.btn-primary:hover{
  transform:translateY(-2px);
  box-shadow:0 8px 24px rgba(59,130,246,.35);
}
.btn-outline{
  background:rgba(255,255,255,.04);
  color:#e2e8f0 !important;
  border:1px solid rgba(255,255,255,.1);
}
.btn-outline:hover{
  border-color:rgba(255,255,255,.2);
  background:rgba(255,255,255,.08);
}
.btn-lg{padding:14px 32px;font-size:15px;border-radius:10px;}

/* ====== Reveal Animation ====== */
.reveal{opacity:0;transform:translateY(32px);transition:opacity 0.8s ease,transform 0.8s cubic-bezier(.4,0,.2,1)}
.reveal.visible{opacity:1;transform:translateY(0)}
.reveal-delay-1{transition-delay:0.12s}
.reveal-delay-2{transition-delay:0.24s}
.reveal-delay-3{transition-delay:0.36s}
.reveal-delay-4{transition-delay:0.48s}

/* ====== Scrollbar ====== */
::-webkit-scrollbar{width:6px}
::-webkit-scrollbar-track{background:#0b1120}
::-webkit-scrollbar-thumb{background:rgba(255,255,255,.1);border-radius:3px}
::-webkit-scrollbar-thumb:hover{background:rgba(255,255,255,.18)}

/* ====== Selection ====== */
::selection{background:rgba(59,130,246,.3);color:#fff}

/* ====== Responsive ====== */
@media(max-width:768px){
  .section{padding:64px 0}
  .section-header{margin-bottom:40px}
}
</style>
